import { render } from "./characteristicItemName.vue?vue&type=template&id=2bcdbe38&scoped=true"
import script from "./characteristicItemName.vue?vue&type=script&lang=js"
export * from "./characteristicItemName.vue?vue&type=script&lang=js"

import "./characteristicItemName.vue?vue&type=style&index=0&id=2bcdbe38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bcdbe38"]])

export default __exports__